import { Slice } from './types'
import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

const getSlice = (state: any): Slice => {
  return state.quote.placeOrderNext
}

export const getPlaceOrder = (cartId: CartId) => (state: RootState) => {
  const slice = getSlice(state)
  return slice[cartId ?? ''] ?? {}
}

export const getOrderId= (cartId: CartId) => (state: RootState) => {
  const order = getPlaceOrder(cartId)(state)
  return order.payload?.placeOrder.order?.order_id
}

export const getErrorMessage = (cartId: CartId) => (state: RootState): string | undefined => {
  const order = getPlaceOrder(cartId)(state)
  const { isFailure, payload } = order ?? {}
  if (isFailure) {
    const message = payload?.placeOrder.errors?.message
    return message
  }
}
